module.exports = __webpack_public_path__ + "static/img/3.3002d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20200423/3.png
// module id = 196W
// module chunks = 1